import React from "react";
import { Link } from "react-router-dom";
import {
    Box,
    AppBar,
    Toolbar,
    Button,
    Container,
    useTheme,
    Divider
} from "@mui/material";
import ArticleIcon from '@mui/icons-material/Article';
import VpnKeyIcon from '@mui/icons-material/VpnKey';
import SportsBarIcon from '@mui/icons-material/SportsBar';
import LanguageSwitcher from './LanguageSwitcher';
import { useTranslation } from "react-i18next";

const Navbar = () => {
    const theme = useTheme();
    const { t, i18n } = useTranslation();
    const currentLang = i18n.language || 'en';

    return (
        <AppBar
            position="static"
            elevation={0}
            sx={{
                backgroundColor: 'transparent',
                backgroundImage: 'none',
                borderBottom: `1px solid ${theme.palette.divider}`,
                mb: 3
            }}
        >
            <Container maxWidth="lg">
                <Toolbar disableGutters sx={{ justifyContent: 'center' }}>
                    <Box sx={{
                        display: 'flex',
                        gap: 1,
                        overflowX: 'auto',
                        py: 1,
                        px: 1,
                        scrollbarWidth: 'none',  // For Firefox
                        '&::-webkit-scrollbar': { // For Chrome/Safari
                            display: 'none'
                        }
                    }}>
                        {/* <Button
                            component={Link}
                            to="/"
                            startIcon={<HomeIcon />}
                            sx={{
                                minWidth: 120,
                                borderRadius: '20px',
                                textTransform: 'none',
                                fontWeight: 600,
                                color: theme.palette.text.primary,
                                '&:hover': {
                                    backgroundColor: theme.palette.action.hover,
                                }
                            }}
                        >
                            Home
                        </Button>

                        <Divider orientation="vertical" flexItem /> */}

                        <Button
                            component={Link}
                            to={`/${currentLang}`}
                            startIcon={<VpnKeyIcon />}
                            sx={{
                                minWidth: 120,
                                borderRadius: '20px',
                                textTransform: 'none',
                                fontWeight: 600,
                                color: theme.palette.text.primary,
                                '&:hover': {
                                    backgroundColor: theme.palette.action.hover,
                                }
                            }}
                        >
                            {t('navbar.secret')}
                        </Button>

                        <Divider orientation="vertical" flexItem />

                        <Button
                            component={Link}
                            to={`/${currentLang}/blogs`}
                            startIcon={<ArticleIcon />}
                            sx={{
                                minWidth: 120,
                                borderRadius: '20px',
                                textTransform: 'none',
                                fontWeight: 600,
                                color: theme.palette.text.primary,
                                '&:hover': {
                                    backgroundColor: theme.palette.action.hover,
                                }
                            }}
                        >
                            {t('navbar.blogs')}
                        </Button>

                        <Divider orientation="vertical" flexItem />

                        <Button
                            component="a"
                            href="https://truthordarefun.com/"
                            target="_blank"
                            rel="noopener noreferrer"
                            startIcon={<SportsBarIcon />}
                            sx={{
                                minWidth: 180,
                                borderRadius: '20px',
                                textTransform: 'none',
                                fontWeight: 600,
                                color: theme.palette.text.primary,
                                '&:hover': {
                                    backgroundColor: theme.palette.action.hover,
                                }
                            }}
                        >
                            {t('navbar.truthOrDare')}
                        </Button>

                        {/* <Divider orientation="vertical" flexItem />

                        <Button
                            component={Link}
                            to="/contact"
                            startIcon={<ContactMailIcon />}
                            sx={{
                                minWidth: 120,
                                borderRadius: '20px',
                                textTransform: 'none',
                                fontWeight: 600,
                                color: theme.palette.text.primary,
                                '&:hover': {
                                    backgroundColor: theme.palette.action.hover,
                                }
                            }}
                        >
                            Contact
                        </Button>  */}
                    </Box>
                    
                    <Box sx={{ 
                        ml: 'auto', 
                        display: 'flex',
                        alignItems: 'center',
                        borderRadius: '28px',
                        px: 0.5,
                        '&:hover': {
                            backgroundColor: theme.palette.action.hover,
                        },
                        transition: 'background-color 0.3s'
                    }}>
                        <LanguageSwitcher />
                    </Box>
                </Toolbar>
            </Container>
        </AppBar>
    );
};

export default Navbar;